// === DÉTECTION ET HELPERS MOBILE ===
// Détecte si le jeu tourne sur mobile et fournit des constantes adaptées.

import { isMobileOrTablet, getDeviceType } from './DeviceUtils';

/** Détecte si l'appareil est un mobile/tablette (rétro-compat, utilise DeviceUtils) */
export function isMobileDevice(): boolean {
  return isMobileOrTablet();
}

/** Détecte si l'écran est en mode portrait */
export function isPortrait(): boolean {
  return window.innerHeight > window.innerWidth;
}

/**
 * Détermine si le layout mobile (portrait 450×800) doit être utilisé.
 * - Mobile → toujours layout mobile
 * - Tablette portrait → layout mobile
 * - Tablette paysage → layout desktop/wide (800×700)
 * - Desktop → layout desktop
 */
function useMobileLayout(): boolean {
  const deviceType = getDeviceType();
  if (deviceType === 'mobile') return true;
  if (deviceType === 'tablet') return isPortrait(); // paysage → desktop
  return false;
}

// === DIMENSIONS INTERNES DU JEU ===
// Desktop / tablette paysage : 800×700 — Mobile / tablette portrait : 450×800
// Phaser scale le canvas, le jeu tourne toujours à résolution fixe.
const _mobile = useMobileLayout();
export const GAME_W = _mobile ? 450 : 800;
export const GAME_H = _mobile ? 800 : 700;
// Debug : log de la détection au chargement
const _deviceType = getDeviceType();
console.log(`[Deadtide] Device: ${_deviceType}${_deviceType === 'tablet' ? ` (${isPortrait() ? 'portrait' : 'paysage'})` : ''} → layout ${_mobile ? 'mobile' : 'desktop'} ${GAME_W}×${GAME_H}`);
/** Centre horizontal du jeu */
export const GAME_CX = GAME_W / 2;
/** Centre vertical du jeu */
export const GAME_CY = GAME_H / 2;

/**
 * Taille de police adaptée : sur mobile on augmente légèrement
 * pour compenser le scaling du canvas.
 */
export function fontSize(desktop: number): string {
  const bonus = _mobile ? 1 : 0;
  return `${desktop + bonus}px`;
}

/**
 * Demande le plein écran sur mobile (appelé au premier tap).
 * Nécessite d'être déclenché par un geste utilisateur.
 */
export function requestFullscreen(): void {
  const el = document.documentElement;
  if (el.requestFullscreen) {
    el.requestFullscreen().catch(() => { /* ignoré si refusé */ });
  } else if ((el as any).webkitRequestFullscreen) {
    (el as any).webkitRequestFullscreen();
  }
}

/**
 * Verrouille l'orientation en paysage si l'API est disponible.
 * UNIQUEMENT sur desktop — sur mobile on reste en portrait.
 */
export function lockLandscape(): void {
  if (_mobile) return; // Portrait sur mobile
  try {
    const orientation = (screen as any).orientation;
    if (orientation?.lock) {
      orientation.lock('landscape').catch(() => { /* API non supportée ou refusée */ });
    }
  } catch {
    // API non disponible
  }
}
